<template>
    <div class="login">
        <div class="login-box">
            <div class="login-left">
                <img :src="loginIcon" alt="">
            </div>
            <div class="login-right">
                <div class="login-right-box" v-show="loginStep">
                    <!--<ul class="login-right-tab">
                        <li class="tab-li"
                            :class="currentForm == 1 ? 'tab-li-active' : ''"
                            @click="loginType(1)"
                        >
                            手机短信登录
                        </li>
                        <li class="tab-li"
                            :class="currentForm == 0 ? 'tab-li-active' : ''"
                            @click="loginType(0)"
                        >
                            账号密码登录
                        </li>
                    </ul>-->
                    <ul class="login-right-tab" style="border: none;justify-content: flex-start;">
                        <li class="tab-li">
                            {{ currentForm == 1 ? '手机短信登录' : '账号密码登录' }}
                        </li>
                    </ul>

                    <el-form :model="form" ref="form">
                        <div class="login-form">
                            <div class="form-zh" v-show="currentForm == 0">
                                <el-input class="tel-input"
                                          placeholder="手机号"
                                          v-model="form.telephone"
                                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                                          maxlength="11"
                                >
                                </el-input>
                                <el-input type="password"
                                          class="password-input"
                                          placeholder="密码"
                                          v-model="form.password"
                                >
                                </el-input>
                            </div>
                            <div class="form-zh" v-show="currentForm == 1">
                                <el-input class="tel-input"
                                          placeholder="手机号"
                                          v-model="form.kjTelephone"
                                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                                          maxlength="11"
                                >
                                </el-input>
                                <div class="verificationCode">
                                    <el-input class="code-input"
                                              placeholder="短信验证码"
                                              v-model="form.kjCode"
                                    >

                                    </el-input>
                                    <div class="getCode">
                                        <span class="getCodeBtn" v-show="!sendSuccess" @click="getCode()">获取验证码</span>
                                        <span class="getCodeTime" v-show="sendSuccess">
                                            发送成功{{ sixten }}s
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-zh-forget">
                                <div class="form-zh-automatic">
                                    <el-checkbox v-model="checked">下次自动登录</el-checkbox>
                                </div>
                                <!--<div class="forget-password" @click="forgetPwd()">
                                    忘记密码
                                </div>-->

                                <div class="forget-password" @click="changeLoginBtn()">
                                    {{ currentForm == 0 ? '手机短信登录' : '账号密码登录' }}
                                </div>
                            </div>
                            <div class="login-btn" @click="loginSubmit()">
                                立即登录
                            </div>
                            <div class="form-zh-forget">
                                <div class="form-zh-automatic">
                                    <span style="color: #666;font-size: 12px">登录即代表您同意</span>
                                    <span style="color: #999;font-size: 12px;text-decoration: underline;" @click="toPercent(0)">《保时达用户服务协议》</span><span style="color: #999;font-size: 12px;text-decoration: underline;" @click="toPercent(1)">《隐私政策》</span>
                                </div>
                            </div>
                            <div class="login-bottom">
                                <div class="form-zh-left">
                                    <img :src="weixinIcon" alt="">
                                    <span>微信扫码登录</span>
                                </div>
                                <!--<div class="register" @click="registration()">免费注册</div>-->
                            </div>
                        </div>
                    </el-form>
                </div>

                <div class="registercontent" v-show="!loginStep">
                    <div class="registercontent-title">
                        用户注册
                    </div>

                    <el-form :model="formRegister" ref="formRegister">
                        <div class="login-form">
                            <div class="form-zh">
                                <el-input class="tel-input" placeholder="手机号"
                                          v-model="formRegister.telephone"></el-input>
                                <div class="verificationCode">
                                    <el-input class="code-input" placeholder="短信验证码"
                                              v-model="formRegister.code"></el-input>
                                    <div class="getCode">
                                        <span class="getCodeBtn" v-show="showTime" @click="getCodeReg()">获取验证码</span>
                                        <span class="getCodeTime" v-show="!showTime">{{ sendTime }}s</span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-zh-forget">
                                <div class="form-zh-automatic">
                                    <el-checkbox v-model="formRegister.checked">我已同意并接受</el-checkbox>
                                    <span>《保时达用户服务协议》</span>、<span>《隐私政策》</span>
                                </div>
                            </div>
                            <div class="login-btn" @click="toRegister()">
                                立即注册
                            </div>
                            <div class="login-bottom-zhuce">
                                <div class="register-zhuce" @click="toLogin()">立即登录</div>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>

        <home-footer></home-footer>
    </div>
</template>

<script>
    import HomeFooter from '@/components/homeFooter';
    import store from '@/store/index';
    import {mapState, mapMutations} from 'vuex';

    export default {
        name: "login",
        components: {
            HomeFooter
        },
        data() {
            return {
                loginStep: true,
                loginIcon: require('@/assets/images/login/login_img_left.png'),
                form: {
                    telephone: '',
                    password: '',
                    kjTelephone: '',
                    kjCode: ''
                },
                checked: false,
                weixinIcon: require('@/assets/images/login/login_icon_wechat.png'),
                currentForm: 1,
                formRegister: {
                    telephone: '',
                    code: '',
                    checked: false
                },
                showTime: true, /* 布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
                sendTime: '', /* 倒计时 计数器 */
                timer: null,
                sixten: 60, //60秒倒计时
                sendSuccess: false, //短信是否发送成功
                userToken: '',
            }
        },

        methods: {
            ...mapMutations(['changeLogin', 'checkAuth', 'abc', 'saveUser', 'saveTimUid']),
            /*发送验证码时，开始计数，一分钟发送一次*/
            getCode() {
                const TIME_COUNT = 60; //  更改倒计时时间
                var that = this;
                var phone = that.form.kjTelephone; //手机号码
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(phone)) {
                    // layer.msg('请输入正确的手机号码！', {
                    //     icon: 2
                    // });
                    this.$message('请输入正确的手机号码');
                    return;
                }
                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/
                that.$axios.post("/getVerfyCode", {
                    phone: phone,
                    use_type: 4,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // layer.closeAll();
                        // layer.msg(res.message);
                        this.$message(res.message);
                        /*if (!this.timer) {
                            this.sendTime = TIME_COUNT;
                            this.showTime = false;
                            this.timer = setInterval(() => {
                                if (this.sendTime > 0 && this.sendTime <= TIME_COUNT) {
                                    this.sendTime--;
                                } else {
                                    this.showTime = true;
                                    clearInterval(this.timer); // 清除定时器
                                    this.timer = null;
                                }
                            }, 1000);
                        }*/
                        that.sendSuccess = true;
                        //倒计时
                        that.time_down();
                    } else {
                        // layer.closeAll();
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }//请求成功返回的数据
                }).catch((error) => {
                    // layer.closeAll();
                    // layer.msg('系统错误', {
                    //     icon: 2
                    // });
                    this.$message('系统错误');
                });
            },

            //倒计时注册
            time_down() {
                var that = this;
                //记录点击时间
                var t1 = window.setInterval(function () {
                    var num = that.sixten;
                    num = num - 1;
                    if (num < 1) {
                        that.sendSuccess = false;
                        window.clearInterval(t1);
                        that.sixten = 60;
                    } else {
                        that.sixten = num;
                    }
                }, 1000);
            },

            loginType(idx) {
                this.currentForm = idx;
            },

            // 免费注册
            registration() {
                this.loginStep = false;
            },

            // 去登录
            toLogin() {
                this.loginStep = true;
            },

            forgetPwd() {
                this.$router.push({path: ''});
            },

            // 切换登录方式
            changeLoginBtn() {
                if (this.currentForm == 1) {
                    this.currentForm = 0;
                } else if (this.currentForm == 0) {
                    this.currentForm = 1;
                }
            },

            // 账号登录 、 快捷登录
            loginSubmit() {
                var that = this;
                var loginType = that.currentForm;
                if (loginType == '0') { //账号登录
                    var phone = that.form.telephone;
                    var pwd = that.form.password;
                    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                    if (!myreg.test(phone)) {
                        /*this.$message({
                          message: "请输入正确的手机号码！",
                          center: true,
                        });*/
                        // layer.msg("请输入正确的手机号码！", {icon: 2});
                        this.$message('请输入正确的手机号码！');
                        return;
                    }
                    if (pwd.length == "") {
                        // this.$message({
                        //   message: "请输入密码！",
                        //   center: true,
                        // });
                        // layer.msg("请输入密码！", {icon: 2});
                        this.$message('请输入密码！');
                        return;
                    }
                   /* var index;
                    layui.use("layer", function () {
                        var layer = layui.layer;
                        index = layer.load(1, {
                            shade: [0.1, "#fff"],
                        });
                    });*/

                    that.$axios.post("/passwordLogin", {
                        phone: phone,
                        password: pwd,
                    }).then((res) => {
                        // layer.close(index);
                        res = res.data;
                        // console.log(res.data); //is_auth,token
                        if (res.status == 200) {
                            // 保存token
                            // localStorage.setItem("token", res.data.token);
                            that.userToken = 'Bearer ' + res.data.token;
                            that.changeLogin({userToken: that.userToken}); // 将用户token保存到vuex中
                            that.saveUser({userName: phone});  // 将登陆用户名保存到vuex中
                            that.saveTimUid({userTimUid: res.data.timUid});  // 将登陆用户名保存到vuex中
                            this.$router.push({path: '/home'});

                        } else {
                            // layer.msg(res.message, {icon: 2});
                            this.$message(res.message);
                        }
                    }).catch((error) => {
                        /*layer.close(index);
                        layer.msg('系统错误', {
                            icon: 2
                        });*/
                        this.$message('系统错误');
                    });
                } else if (loginType == '1') { //快捷登录
                    var that = this;
                    var phone = that.form.kjTelephone;
                    var yzm = that.form.kjCode;
                    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                    if (!myreg.test(phone)) {
                        // layer.msg("请输入正确的手机号码！", {icon: 2});
                        this.$message('请输入正确的手机号码！');
                        return;
                    }
                    if (yzm.length < 1) {
                        /*layer.msg('请输入短信验证码', {
                            icon: 2
                        });*/
                        this.$message('请输入短信验证码！');
                        return;
                    }
                    /*var index;
                    layui.use('layer', function () {
                        var layer = layui.layer;
                        index = layer.load(1, {
                            shade: [0.1, '#fff'] //0.1透明度的白色背景
                        });
                    });*/
                    that.$axios.post("/verifyLogin", {
                        phone: phone,
                        verifyCode: yzm,
                    }).then((res) => {
                        res = res.data;
                        // console.log(res);
                        if (res.status == 200) {
                            // layer.close(index);
                            // 保存token
                            // localStorage.setItem("token", res.data.token);
                            that.userToken = 'Bearer ' + res.data.token;
                            that.changeLogin({userToken: that.userToken});  // 将用户token保存到vuex中
                            that.saveUser({userName: phone});  // 将登陆用户名保存到vuex中
                            that.saveTimUid({userTimUid: res.data.timUid});  // 将登陆用户名保存到vuex中
                            // 保存是否完善
                            // that.auth = res.data.is_auth;
                            // 保存是否完善保存到vuex中
                            // that.checkAuth({is_auth: that.auth});
                            this.$router.push({path: '/home'});
                            that.sendSuccess = true;
                            that.sixten = 60;
                        } else {
                            // layer.msg(res.message, {icon: 2});
                            // layer.close(index);
                            this.$message(res.message);
                            that.form.kjCode = '';
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },

            // 跳转至用户服务协议
            toPercent(word){
                this.$router.push({name: 'HelpCenter',params: { type: word}});
            },

            // 注册
            toRegister() {
                var that = this;
                var tel = that.formRegister.telephone;
                var code = that.formRegister.code;
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(tel)) {
                    // layer.msg("请输入正确的手机号码！", {icon: 2});
                    this.$message('请输入正确的手机号码！');
                    return;
                }
                if (code.length < 1) {
                    /*layer.msg('请输入短信验证码', {
                        icon: 2
                    });*/
                    this.$message('请输入短信验证码！');
                    return;
                }
                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/

                that.$axios.post("/verifyLogin", {
                    phone: tel,
                    verifyCode: code,
                }).then((res) => {
                    // layer.close(index);
                    res = res.data;
                    console.log(res);
                    return;
                    if (res.status == 200) {
                        // 保存token
                        // localStorage.setItem("token", res.data.token);
                        that.userToken = 'Bearer ' + res.data.token;
                        that.changeLogin({userToken: that.userToken});  // 将用户token保存到vuex中
                        that.saveUser({userName: phone});  // 将登陆用户名保存到vuex中
                        // 保存是否完善
                        // that.auth = res.data.is_auth;
                        // 保存是否完善保存到vuex中
                        // that.checkAuth({is_auth: that.auth});
                        this.$router.push({path: '/home'});
                        that.sendSuccess = true;
                        that.sixten = 60;
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        // layer.close(index);
                        this.$message(res.message);
                        that.form.kjCode = '';
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
    @import './login.css';
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue